import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Modal } from "@/Common/Components/Modals/Modal";
import { HealthInsuranceEligibility } from "@/Common/Models/Patient/HealthInsuranceEligibility/HealthInsuranceEligibility";
import { HealthInsuranceEligibilityStatus } from "@/Common/Models/Patient/HealthInsuranceEligibility/HealthInsuranceEligibilityStatus";

import styles from "./MedicalServicesPlanCoverageInformationPopup.module.scss";

interface IMedicalServicesPlanCoverageInformationPopupProps {
    mspEligibility: HealthInsuranceEligibility;
    xPosition: number;
    yPosition: number;
    onCloseCallback: () => void;
    isMissingPHN?: boolean;
    isMissingDateOfBirth?: boolean;
    isPersonalHealthNumberInvalid?: boolean;
}

class MedicalServicesPlanCoverageInformationPopup extends BaseReactComponent<IMedicalServicesPlanCoverageInformationPopupProps, any> {
    private readonly noRestriction = "NO RESTRICTION";
    public render(): JSX.Element {
        return (
            <Modal
                title={cacheStore.GetString("MedicalServicesPlanAbbrevCoverageLabel")}
                left={this.props.xPosition}
                top={this.props.yPosition - ($(".myle-page-header")?.position()?.top ?? 0)}
                width={300}
                onClose={() => this.props.onCloseCallback()}
                showX
                draggable
                fixedOverlayPosition
            >
                <span>
                    {this.props.isMissingPHN && this.props.isMissingDateOfBirth && (
                        cacheStore.GetString("PersonalHealthNumberAndDateOfBirthMissingLabel")
                    )}
                    {this.props.isMissingPHN && !this.props.isMissingDateOfBirth && (
                        cacheStore.GetString("PersonalHealthNumberMissingLabel")
                    )}
                    {this.props.isPersonalHealthNumberInvalid && !this.props.isMissingPHN && (
                        cacheStore.GetString("PersonalHealthNumberInvalidLabel")
                    )}
                    {this.props.isMissingDateOfBirth && !this.props.isMissingPHN && (
                        cacheStore.GetString("DateOfBirthMissingLabel")
                    )}
                    {this.props.mspEligibility.Eligibility === HealthInsuranceEligibilityStatus.Unknown && (
                        cacheStore.GetString("MedicalServicesPlanAbbrevCoverageErrorLabel")
                    )}
                </span>
                {(!IsNullOrWhiteSpace(this.props.mspEligibility.EligibilityMessage) || !IsNullOrWhiteSpace(this.props.mspEligibility.PatientRestriction)) && (
                    <div className="width-100">
                        {this.renderRow(`${cacheStore.GetString("EligibilityMessageLabel")}: `, this.props.mspEligibility.EligibilityMessage)}
                        {this.renderRow(`${cacheStore.GetString("RestrictionsLabel")}: `, this.props.mspEligibility.PatientRestriction)}
                    </div>
                )}
            </Modal>
        );
    }

    private renderRow(label: string, content: string): JSX.Element {
        if (!content || content === this.noRestriction)
            return null;

        return (
            <div className={styles.row}>
                <strong>{label}</strong>
                <span>{this.formatResponse(content)}</span>
            </div>
        );
    }

    private formatResponse(text: string): string {
        const sentences = text.toLowerCase().split(". ");
        for (let i = 0; i < sentences.length; i++) {
            sentences[i] = sentences[i].charAt(0).toUpperCase() + sentences[i].substring(1);
        }

        return sentences
            .join(". ")
            .replace("phn", "PHN")
            .replace("msp", "MSP");
    }
}

export { MedicalServicesPlanCoverageInformationPopup };
